<!-- Google Tag Manager (noscript) -->
<noscript *ngIf="brandInfo != undefined">
  <iframe [src]="gtmUrl | safe" height="0" width="0"
          style="display:none;visibility:hidden"></iframe>
</noscript>
<!-- End Google Tag Manager (noscript) -->
<meta name="viewport" content="width=device-width, initial-scale=1.0">

<app-header-div *ngIf="brandInfo != undefined" [logoUrl]="brandInfo.CarrierLogo" [contactNumber]="contactNumber">
</app-header-div>
<router-outlet>
</router-outlet>
<app-footer *ngIf="brandInfo != undefined" [privacyPolicyLink]="brandInfo.PrivacyPolicyUrl"
        [termsOfUseLink]="brandInfo.TermsOfUseUrl"
        [programFactsLink]="brandInfo.ProgramFactsUrl"
        [oneTrustWebformLink]="brandInfo.OneTrustWebformUrl"
>
</app-footer>
